import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Cara = () => {
  const data = useStaticQuery(graphql`
    query {
      caraImage: file(relativePath: { eq: "cara.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return <Img fluid={data.caraImage.childImageSharp.fluid} alt="Cara" />
}

export default Cara
